import Skeleton from '@mui/material/Skeleton';
import { CampaignCardProps } from './campaign-card-props';

export function CampaignCardSkeleton({
  props,
  animated = true,
}: {
  props?: CampaignCardProps;
  animated?: boolean;
}) {
  return (
    <div
      className="qlf-skeleton"
      style={{
        animation: animated ? 'pulse 1.5s infinite' : 'none',
        width: '100%',
        margin: '0 auto',
        borderRadius: '12px',
        backgroundColor: '#fff',
        boxShadow: '0 0 15px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: '0.3s',
      }}
    >
      <div style={{ height: '200px', width: '100%' }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ animation: animated ? undefined : 'none' }}
        />
      </div>

      <div
        style={{
          padding: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.8rem',
        }}
      >
        <Skeleton
          variant="text"
          width="60%"
          sx={{ fontSize: '1.8rem', animation: animated ? undefined : 'none' }}
        />
        <Skeleton
          variant="text"
          width="100%"
          sx={{ fontSize: '1.1rem', animation: animated ? undefined : 'none' }}
        />
        <Skeleton
          variant="text"
          width="100%"
          sx={{ fontSize: '1.1rem', animation: animated ? undefined : 'none' }}
        />
        <Skeleton
          variant="text"
          width="70%"
          sx={{ fontSize: '1.1rem', animation: animated ? undefined : 'none' }}
        />
        <Skeleton
          variant="rectangular"
          width="8rem"
          height="2.5rem"
          sx={{ borderRadius: '20px', animation: animated ? undefined : 'none' }}
        />
      </div>
    </div>
  );
}
